export default __webpack_public_path__ + "static/Metal_Stairs-35519d3693e8abd8bc966162c0688469.png";